import gql from "graphql-tag";

export const activateMembership = gql`
  mutation ActivateMembership($input: ActivateMembershipRequestInput) {
    ActivateMembership(input: $input) {
      success
    }
  }
`;
